import axios, { AxiosResponse } from 'axios';
import { userApi } from 'constants/api';


export class ProfileTypeService {
  get = async (): Promise<AxiosResponse> => axios.get('/auth/user/profileType');
  delete = async (): Promise<AxiosResponse> => axios.delete('/auth/auth/logout');
  acceptPersonalData = async (): Promise<AxiosResponse> => axios.put(`${userApi}/putPersonalDataAgreement`);
}
